// extracted by mini-css-extract-plugin
module.exports = {"content":"VideoTutorialDetailTemplate_content__3cS9i","rotation":"VideoTutorialDetailTemplate_rotation__uIDmP"};